import React from "react";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { Kicker, PageHero, Section, CardGrid } from "@/components/Primitives";

const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1784928308199-01fab3361a5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  const { t } = useI18n();
  return (
    <div data-testid="about-page">
      <Seo pageKey="about" />
      <PageHero kicker={t("about.kicker")} title={t("about.title")} lead={t("about.lead")} image={ABOUT_IMAGE} />

      <Section>
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="text-base leading-relaxed text-foreground/90 sm:text-lg">{t("about.p1")}</p>
            <p className="mt-8 text-sm leading-relaxed text-muted-foreground sm:text-base">{t("about.p2")}</p>
          </div>
          <div className="md:col-span-5">
            <Kicker>{t("about.scaleKicker")}</Kicker>
            <h2 className="mt-4 font-display text-2xl font-medium">{t("about.scaleTitle")}</h2>
            <p className="mt-3 text-sm text-muted-foreground">{t("about.scaleBody")}</p>
            <ul data-testid="about-scale" className="mt-6 divide-y divide-border border-y border-border">
              {t("about.scaleItems").map((item) => (
                <li key={item} className="py-3 text-sm">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>

      <Section className="bg-secondary/40">
        <Kicker>{t("about.valuesKicker")}</Kicker>
        <CardGrid items={t("about.values")} testIdPrefix="about-value" />
      </Section>
    </div>
  );
}
